

import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { useToast } from './ToastProvider';
import FormField from './common/FormField';
import { useForm } from './common/useForm';


const PartOrderForm = () => {
  const [form, handleChange, setForm] = useForm({ phone: '', deliveryAddress: '', partId: '', quantity: 1, note: '' });
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { showToast } = useToast();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    api.get('/parts?isActive=true')
      .then(res => setParts(res.data.items || []))
      .catch(() => setError('Сэлбэгийн жагсаалт авах үед алдаа гарлаа'))
      .finally(() => setLoading(false));
  }, []);

  // Custom handleChange for quantity to ensure min=1
  const handleFieldChange = e => {
    const { name, value } = e.target;
    if (name === 'quantity') {
      handleChange({
        target: { name, value: Math.max(1, Number(value)), type: 'number' }
      });
    } else {
      handleChange(e);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess(false);
    try {
      if (!form.partId) throw new Error('Сэлбэг сонгоно уу');
      if (!form.phone || !form.deliveryAddress) throw new Error('Утас болон хаяг заавал бөглөнө');
      const orderData = {
        phone: form.phone,
        deliveryAddress: form.deliveryAddress,
        note: form.note,
        items: [
          { productId: form.partId, qty: form.quantity }
        ]
      };
      await api.post('/partOrders', orderData);
      setSuccess(true);
      setForm({ phone: '', deliveryAddress: '', partId: '', quantity: 1, note: '' });
      showToast('Захиалга амжилттай илгээгдлээ!', 'success');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Захиалга илгээхэд алдаа гарлаа');
      showToast(err.response?.data?.message || err.message || 'Захиалга илгээхэд алдаа гарлаа', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h2>Сэлбэг захиалга</h2>
      {loading && <div>Ачааллаж байна...</div>}
      {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
      <form className="part-order-form" onSubmit={handleSubmit}>
        <FormField
          type="input"
          label="Утас"
          name="phone"
          value={form.phone}
          onChange={handleFieldChange}
          placeholder="Утасны дугаар"
          required
        />
        <FormField
          type="input"
          label="Хүргэлтийн хаяг"
          name="deliveryAddress"
          value={form.deliveryAddress}
          onChange={handleFieldChange}
          placeholder="Хаяг"
          required
        />
        <FormField
          type="select"
          label="Сэлбэг сонгох"
          name="partId"
          value={form.partId}
          onChange={handleFieldChange}
          required
          options={[
            { value: '', label: 'Сэлбэг сонгох' },
            ...parts.map(part => ({
              value: part.id,
              label: `${part.name} (${part.price?.toLocaleString?.() || 0}₮)`
            }))
          ]}
        />
        <FormField
          type="input"
          label="Тоо"
          name="quantity"
          typeInput="number"
          min="1"
          value={form.quantity}
          onChange={handleFieldChange}
          placeholder="Тоо"
          required
        />
        <FormField
          type="textarea"
          label="Тайлбар"
          name="note"
          value={form.note}
          onChange={handleFieldChange}
          placeholder="Тайлбар (заавал биш)"
        />
        <button type="submit" disabled={submitting}>{submitting ? 'Илгээж байна...' : 'Захиалах'}</button>
      </form>
      {/* Toast мэдэгдэл рүү шилжүүлсэн */}
      <style>{`
        .part-order-form {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          max-width: 500px;
          margin: 0 auto;
          background: #fafbfc;
          border-radius: 12px;
          padding: 18px 16px;
          border: 1px solid #eee;
        }
        .part-order-form input,
        .part-order-form select,
        .part-order-form textarea {
          width: 100%;
          padding: 10px;
          border-radius: 7px;
          border: 1px solid #ddd;
          font-size: 1em;
          font-family: inherit;
          box-sizing: border-box;
        }
        .part-order-form textarea {
          grid-column: 1 / -1;
          min-height: 48px;
        }
        .part-order-form button {
          grid-column: 1 / -1;
          padding: 12px;
          border-radius: 7px;
          background: #2563eb;
          color: #fff;
          font-weight: 600;
          border: none;
          font-size: 1.1em;
          cursor: pointer;
          transition: background 0.18s;
        }
        .part-order-form button:disabled {
          background: #b6c3d1;
          cursor: not-allowed;
        }
        @media (max-width: 600px) {
          .part-order-form {
            grid-template-columns: 1fr;
            gap: 10px;
            padding: 12px 6px;
          }
        }
      `}</style>
    </div>
  );
};

export default PartOrderForm;
